export default __webpack_public_path__ + "images/f975179eda5226c21b1168dcbf768006-easter.jpg";